import { Swiper, SwiperSlide } from 'swiper/react';
import { useCallback, useRef } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';

type VideoPlayTabType = keyof typeof PLAY_VIDEO_INDEX_MAP;

const PLAY_VIDEO_INDEX_MAP = {
    rv: 0,
    grid: 4,
    home: 7,
};

const curTabIndex = {
    rv: 0,
    grid: 4,
    home: 7,
};

let timerVideoPlay: NodeJS.Timeout;
let timerFirstVideo: NodeJS.Timeout;

export default function SwiperA({ data = {}, tab = 'rv', tabHide = false }: any) {
    const { useState, useLang, useEffect } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const { title0 = '', title1, title2, list } = data;
    const [swiper, setSwiper] = useState({ activeIndex: 1 });
    const [active, setActive] = useState(0);
    // 组建第一个视频 加载完成自动播放 并且是rv-tab模块
    const firstVideoRef = useRef<any>(null);

    const onSwiperSlideTo = (index: number) => {
        if (swiper && index !== active) {
            swiper?.slideTo(index);
            setActive(index);
            curTabIndex[tab as VideoPlayTabType] = index + (PLAY_VIDEO_INDEX_MAP[tab as VideoPlayTabType] || 0);
        }
    };

    const onSwiperFn = (swiper: any) => setSwiper(swiper);

    const playVideoFn = useCallback((index: number) => {
        clearTimeout(timerVideoPlay);
        const listVideo = document.querySelectorAll('.swiperA .video') || [];
        listVideo.forEach((item: any) => item?.pause());
        // 要停止后,播放放在异步队列播放
        timerVideoPlay = setTimeout(() => {
            listVideo.length && listVideo[index]?.play();
        }, 100);
    }, []);

    const onSlideChangeFn = useCallback(
        (swiper: any) => {
            setActive(swiper?.activeIndex % list?.length);

            const currentIndex = swiper?.activeIndex + (PLAY_VIDEO_INDEX_MAP[tab as VideoPlayTabType] || 0);
            curTabIndex[tab as VideoPlayTabType] = currentIndex;
            playVideoFn(currentIndex);
        },
        [list?.length, playVideoFn, tab],
    );

    // 监听第一个视频可播放时马上播放
    useEffect(() => {
        if (tab === 'rv') {
            clearInterval(timerFirstVideo);
            timerFirstVideo = setInterval(() => {
                if (firstVideoRef.current) {
                    firstVideoRef.current?.play();
                    clearInterval(timerFirstVideo);
                }
            }, 100);
        }
    }, []);

    useEffect(() => {
        const index = curTabIndex[tab as VideoPlayTabType];
        playVideoFn(index);
    }, [playVideoFn, tab]);

    return (
        <div className={`${css.swiperA} swiperA ${title0 ? 'hasGuide' : ''}`} style={{ paddingBottom: tabHide ? '70px' : 'auto' }}>
            {title0 && (
                <div className="kit-ms0-out">
                    <div className="kit-ms0">{title0}</div>
                </div>
            )}
            <div className="kit-ms1-out">
                <div className="kit-ms1">{title1}</div>
            </div>
            <div className="kit-ms2-out">
                <div className="kit-ms2">{title2}</div>
            </div>
            <Swiper
                className={`mm100-product-swiper ${list?.length === 1 ? 'single' : ''}`}
                slidesPerView={'auto'}
                spaceBetween={30}
                initialSlide={list?.length <= 2 ? 0 : 1}
                preloadImages={false}
                lazy={true}
                centeredSlides={true}
                grabCursor={true}
                navigation
                onSwiper={(swiper: any) => onSwiperFn(swiper)}
                onSlideChange={(swiper: any) => onSlideChangeFn(swiper)}
                speed={800}
            >
                {list?.map((item: any, index: any) => (
                    <SwiperSlide key={index}>
                        <div className="video-box">
                            <div className="video-box-in">
                                {index === 0 && tab === 'rv' ? (
                                    <EFVideo ref={firstVideoRef} sources={item?.src} className="video" />
                                ) : (
                                    <EFVideo sources={item?.src} className="video" />
                                )}
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            {list?.length > 1 && !tabHide && (
                <ul className="paginations">
                    {list.map((item: any, k: number) => (
                        <li className={`pagination-item ${k === active ? 'active' : ''}`} key={k} onClick={() => onSwiperSlideTo(k)}>
                            {t(`presale.product.${item?.i18n}`)}
                            <div className="line"></div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
